
import moment from 'moment';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getUserList } from '@/api/userManaging';
import { PageQuery } from '@/mixins/page_query';
import LogUtils from 'panda-log';
import { toast } from '../../../utils/common';
import InvitationDetail from '@/views/user_manage/user_list/invitation_detail.vue';
@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    hour_miniute(mint: number) {
      let hour: number;
      let miniute: number;
      miniute = mint % 60;

      if (mint > 60) {
        hour = Math.floor(mint / 60);
        if (miniute === 0) {
          return `${hour}小时`;
        } else {
          return `${hour}小时${miniute}分`;
        }
      } else if (mint === 60) {
        return `${mint}分钟`;
      } else {
        return `${miniute}分钟`;
      }
    },
  },
  components: { InvitationDetail },
})
export default class RechargeRecord extends Vue {
  private start!: any;
  private end!: any;
  private dates = '';
  private invitetionVisible: boolean = false;
  private info: any;
  private statusArr = ['全部类型', '正常', '黑名单'];
  private tableData = [
    // {
    //   created_at: -89316166.37838253,
    //   coin: -79481865.03881139,
    //   duration: 120,
    //   id: 27646955.737832665,
    //   is_disable: false,
    //   nickname: 'e',
    // },
  ];

  private query = {
    // is_disable: 0,
    nickname: '',
    uid: '',
    page_size: 30,
    page: 1,
    ygx_id: '',
  };
  total: number = 0;
  private loading = false;

  dateHandler(e: any) {
    this.start = moment(e[0], 'YYYY-MM-DD').unix();
    this.end = moment(e[1])
      .endOf('day')
      .unix();
  }
  searchList() {
    if (!this.query.nickname && !this.query.uid && !this.query.ygx_id) {
      this.$message('请输入查询条件');
      return;
    }
    this.query.page = 1;
    this.getList();
  }
  handleSizeChange(page_size: number) {
    this.query.page = 1;
    this.query.page_size = page_size;
    if (!this.query.nickname && !this.query.uid && !this.query.ygx_id) {
      this.$message('请输入查询条件');
      return;
    }
    this.getList();
  }
  handleCurrentChange(page: number) {
    this.query.page = page;
    if (!this.query.nickname && !this.query.uid && !this.query.ygx_id) {
      this.$message('请输入查询条件');
      return;
    }
    this.getList();
  }
  async getList() {
    try {
      this.loading = true;
      const res = await getUserList(this.query);
      if (res && (res as any).code === 0) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  userDetail(row: any) {
    this.invitetionVisible = true;
    this.info = row;
  }
  mounted() {}
}
